<template>
  <div class="inlineSubtask"
       v-bind:class="{resolved: subtask.resolved, matchingAssignee: highlightAssignee===subtask.shortAssignee, unassigned: markUnassignedIssues && !subtask.assignee && subtask.assigneeRequired}">
    <span v-if="showSubtaskNumbers" class="issueId"><a
        v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issue/'+subtask.id"
        target="_blank">{{subtask.id}}</a></span>
    <a v-bind:href="'https://alightcreative.myjetbrains.com/youtrack/issue/'+subtask.id" target="_blank">
      <span class="assignee" v-if="showAssignees">{{subtask.assignee}}</span>
      {{subtask.summary}}</a>
    <div v-if="showState" class="subtaskState">{{subtask.state}}</div>

    <div v-for="subsubtask in subtask.subtasks" :key="subsubtask.id">
      <RoadmapSubtask :highlight-assignee="highlightAssignee"
                      :mark-unassigned-issues="markUnassignedIssues" :show-assignees="showAssignees"
                      :show-state="showState" :show-subtask-numbers="showSubtaskNumbers"
                      :subtask="subsubtask"/>
    </div>

  </div>
</template>
<script>
export default {
  name: 'RoadmapSubtask',
  props: {
    highlightAssignee: {},
    markUnassignedIssues: {},
    showAssignees: {},
    showState: {},
    showSubtaskNumbers: {},
    subtask: {}
  }
}
</script>
<style lang="scss" scoped>

h1 {
  font-size: 16pt;
  margin-left: 10pt;
}

.inlineSubtask {
  background: rgba(0,0,0,0.1);
  margin-top: 4pt;
  margin-bottom: 2pt;
  margin-right: 2pt;
  padding: 1pt;
  border-radius: 2pt;
  color: #373737;
  margin-left: 12pt;

  &.matchingAssignee {
    border: 1px solid #000000;
    background: #ffe3a3;
  }

  &.unassigned {
    background: #e5b7ea;
  }

  &.resolved {
    text-decoration: line-through;
    opacity: .25;
  }

  a {
    text-decoration: none;
    color: #373737;
  }

  a:visited {
    color: #544660;
  }

  a:hover {
    color: #737373;
    text-decoration: underline;
  }

  .assignee {
    color: #AAA;
    float: right;
    text-align: right;
    margin-right: 2pt;
    font-size: 7pt;
  }

  .subtaskState {
    position: relative;
    right: 0pt;
    bottom: 0pt;
    color: #9589ae;
    text-align: right;
    font-style: italic;
    font-size: 7pt;

    span {
      display: inline-block;
      padding-right: 2pt;
      padding-left: 2pt;
      border-radius: 2pt;
    }

  }

}


</style>